import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, take, catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const requiredRole = route.data['role'] as string | undefined;

    // Se não há role requerido, permite acesso (apenas AuthGuard valida autenticação)
    if (!requiredRole) {
      console.log('[RoleGuard] Nenhuma role requerida, permitindo acesso');
      return of(true);
    }

    console.log('[RoleGuard] Validando role requerida:', requiredRole);

    return this.auth.ensureUserLoaded(5000).pipe(
      take(1),
      map(() => {
        const ok = this.auth.hasRole(requiredRole);
        console.log('[RoleGuard] Validação de role:', requiredRole, '→', ok);
        if (!ok) {
          // redireciona para página de forbidden
          console.warn('[RoleGuard] Usuário não tem role necessária, redirecionando para /forbidden');
          return this.router.parseUrl('/forbidden');
        }
        return true;
      }),
      catchError((err) => {
        console.error('[RoleGuard] Erro ao validar role:', err);
        // Em caso de erro no carregamento de roles, redireciona para forbidden
        return of(this.router.parseUrl('/forbidden'));
      })
    );
  }
}
